/**
 * 班级api
 * 班级api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import TeamVo from './TeamVo';




  /**
   * The PagingTeamVo model module.
   * @module user/model/PagingTeamVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PagingTeamVo</code>.
   * @alias module:user/model/PagingTeamVo
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>PagingTeamVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:user/model/PagingTeamVo} obj Optional instance to populate.
   * @return {module:user/model/PagingTeamVo} The populated <code>PagingTeamVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'pageSize')) {
        obj['pageSize'] = ApiClient.convertToType(data['pageSize'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'pageNum')) {
        obj['pageNum'] = ApiClient.convertToType(data['pageNum'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'total')) {
        obj['total'] = ApiClient.convertToType(data['total'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'pages')) {
        obj['pages'] = ApiClient.convertToType(data['pages'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'list')) {
        obj['list'] = ApiClient.convertToType(data['list'], [TeamVo]);
      }
    }
    return obj;
  }

  /**
   * 每页显示的条数
   * @member {Integer} pageSize
   */
  exports.prototype['pageSize'] = undefined;
  /**
   * 当前页
   * @member {Integer} pageNum
   */
  exports.prototype['pageNum'] = undefined;
  /**
   * 总条数
   * @member {Integer} total
   */
  exports.prototype['total'] = undefined;
  /**
   * 总页数
   * @member {Integer} pages
   */
  exports.prototype['pages'] = undefined;
  /**
   * 当前页下的数据列表
   * @member {Array.<module:user/model/TeamVo>} list
   */
  exports.prototype['list'] = undefined;



  export default exports;
;


